/* globals birthdayData, isMay2, todayData, serverParams */
import confetti from '@hiseb/confetti'
import Table from 'bam-node-savant-table/table'
import initStaticHeaders from './utils/static-headers'

import { populateUrl } from './utils/leaderboard-filter-helpers'

const velocity = 200
const defaultConfettiPosition = { x: 200, y: 200 }
const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
).matches

const shouldShowConfetti = !prefersReducedMotion && isMay2

function fireConfetti(position) {
    if (!shouldShowConfetti) {
        return
    }

    confetti({
        position,
        velocity,
    })
}

function getElementCenterPosition(elementId) {
    const element = document.getElementById(elementId)
    if (!element) {
        return defaultConfettiPosition
    }

    const rect = element.getBoundingClientRect()
    return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
    }
}

function launchLoadConfetti() {
    setInterval(() => {
        fireConfetti(getElementCenterPosition('slbi-may-2'))
        addBoing()
    }, 25 * 1000)

    fireConfetti(getElementCenterPosition('slbi-may-2'))
    addBoing()
}

function addBoing() {
    const $birthdayEl = document.getElementById('slbi-may-2')

    $birthdayEl.classList.add('boing')

    // Cleanup for next time
    setTimeout(() => {
        $birthdayEl.classList.remove('boing')
    }, 2000)
}

if (isMay2) {
    if (document.readyState === 'complete') {
        launchLoadConfetti()
    } else {
        window.addEventListener('load', launchLoadConfetti)
    }

    window.addEventListener('click', (event) => {
        fireConfetti({ x: event.clientX, y: event.clientY })
    })
}

const {
    getTodayHeaders,
    getBirthdayHeaders,
    secondaryHeaders,
} = require('./birthday-index/slbi-headers')

let showInactives
let onlyActiveData

const tableDivId = 'birthday_table'
const todayBattersDivId = 'today_table_batters'
const todayPitchersDivId = 'today_table_pitchers'

function loadTable(filteredData) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }

    const currentParams = new URLSearchParams(window.location.search)

    const defaultSort = currentParams.get('sortColumn') || 'daysUntil'
    const initialSortDirection = currentParams.get('sortDirection') || 'asc'

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        headers: getBirthdayHeaders(showInactives),
        secondaryHeaders,
        highlightFalsy: true,
        data: filteredData,
        defaultSort,
        initialSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
        },
    })

    initStaticHeaders(tableDivId, filteredData)
}

function loadTodayTable(todayData) {
    // eslint-disable-next-line no-new
    new Table({
        id: todayBattersDivId,
        headers: getTodayHeaders(false),
        highlightFalsy: true,
        data: todayData.filter((d) => d.player_type === 'Batter'),
        hasPinned: true,
        defaultSort: 'birthday_index',
        initialSortDirection: 'desc',
        sortClass: 'column-sort',
    })

    // eslint-disable-next-line no-new
    new Table({
        id: todayPitchersDivId,
        headers: getTodayHeaders(true),
        highlightFalsy: true,
        data: todayData.filter((d) => d.player_type === 'Pitcher'),
        hasPinned: true,
        defaultSort: 'birthday_index',
        initialSortDirection: 'desc',
        sortClass: 'column-sort',
    })
}

function formatDate(dateStr) {
    const month = Number(dateStr.split('-')[1]).toString()
    const day = Number(dateStr.split('-')[2]).toString()
    return `${month}-${day}`
}

if (todayData && todayData.length) {
    loadTodayTable(todayData)
}

if (birthdayData && birthdayData.length) {
    const currParams = new URLSearchParams(window.location.search)
    showInactives =
        currParams.get('showInactives') === 'true' ||
        serverParams.showInactives === 'true' ||
        false

    onlyActiveData = birthdayData.filter((d) => d.is_player_active === 1)

    if (!showInactives) {
        loadTable(onlyActiveData)
    } else {
        loadTable(birthdayData)
    }
}

document.getElementById('btn-update').addEventListener('click', () => {
    const urlParams = {
        showInactives,
        minGames: document.getElementById('ddlMinGames')?.value,
    }
    if (document.getElementById('ddlDate')?.value) {
        urlParams.date = formatDate(document.getElementById('ddlDate')?.value)
    }

    window.location = populateUrl(urlParams)
})

document.getElementById('btn-reset').addEventListener('click', () => {
    window.location = '/birthday-index'
})

document.getElementById('btn-active-toggle').addEventListener('click', () => {
    showInactives = !showInactives

    const url = new URL(window.location)
    url.searchParams.set('showInactives', showInactives)
    window.history.replaceState('', '', url.toString())

    if (showInactives) {
        loadTable(birthdayData)
        document.getElementById('btn-active-toggle').innerHTML =
            'Hide Inactive Players'
    } else {
        loadTable(onlyActiveData)
        document.getElementById('btn-active-toggle').innerHTML =
            'Show Inactive Players'
    }
})
